'use strict';

module.exports = require('./es6/crc1').default;
